var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-0",attrs:{"fill-height":""}},[_c('v-row',{staticClass:"text-center",staticStyle:{"height":"100%"}},[_c('v-col',{staticClass:"pb-0",attrs:{"cols":"12"}},[_c('guess-board')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }